import { c as _c } from "react/compiler-runtime";
// «Статистика и финансы» партнёра: период 7/30/90 дней, воронка «переходы ->
// заказы -> выкуп», переходы по дням, таблица по артикулам (у арбитражника -
// CR % и возвраты), баланс (HOLD, доступно к выплате, выплачено,
// аннулировано) и список начислений. Пустые состояния - тексты ТЗ.
import { UGC_TEXTS } from "@osmix/contracts/ugc-articles";
import { Skeleton } from "@osmix/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { UgcAnalytics, UgcBalance, UgcCommission } from "@/api";
import { api } from "@/api";
import { ErrorState } from "@/components/common/states";
import { CodeChip, CommissionStateBadge, EmptyNote, fmtDate, fmtInt, fmtPercent, PartnerCard, partnerKey, StatusBadge } from "@/components/partner/partner-ui";
import { Segmented } from "@/components/ui/segmented";
import { useFormatPrice } from "@/lib/use-format-price";
import { cn } from "@/lib/utils";
import { usePartner } from "./shell";
type Days = "7" | "30" | "90";
export function PartnerStatsPage() {
  const $ = _c(49);
  const {
    t
  } = useTranslation();
  const {
    partner,
    userId
  } = usePartner();
  const [days, setDays] = useState("30");
  const arbitrage = partner.role === "arbitrage";
  let t0;
  if ($[0] !== days || $[1] !== userId) {
    t0 = partnerKey(userId, "stats", days);
    $[0] = days;
    $[1] = userId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== days) {
    t1 = () => api.ugc.partner.stats({
      days: Number(days),
      groupBy: "article"
    });
    $[3] = days;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const stats = useQuery(t2);
  let t3;
  if ($[8] !== userId) {
    t3 = partnerKey(userId, "stats", "commissions");
    $[8] = userId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = {
      queryKey: t3,
      queryFn: _temp
    };
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const commissions = useQuery(t4);
  let t5;
  if ($[12] !== t) {
    t5 = t("partner.stats.period");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("partner.stats.days", {
      count: 7
    });
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = {
      value: "7",
      label: t6
    };
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("partner.stats.days", {
      count: 30
    });
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = {
      value: "30",
      label: t8
    };
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("partner.stats.days", {
      count: 90
    });
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10) {
    t11 = {
      value: "90",
      label: t10
    };
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t7 || $[28] !== t9) {
    t12 = [t7, t9, t11];
    $[26] = t11;
    $[27] = t7;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== days || $[31] !== t12 || $[32] !== t5) {
    t13 = <Segmented aria-label={t5} value={days} onValueChange={setDays} options={t12} />;
    $[30] = days;
    $[31] = t12;
    $[32] = t5;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== stats.data) {
    t14 = stats.data && <span className="text-[13px] leading-[17px] text-ds-secondary">{fmtDate(stats.data.from)} - {fmtDate(stats.data.to)}</span>;
    $[34] = stats.data;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14) {
    t15 = <div className="flex flex-wrap items-center justify-between gap-3">{t13}{t14}</div>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== arbitrage || $[40] !== stats || $[41] !== t) {
    t16 = stats.isPending ? <div className="grid gap-3 md:grid-cols-2"><Skeleton className="h-[180px] rounded-[20px]" /><Skeleton className="h-[180px] rounded-[20px]" /><Skeleton className="h-[220px] rounded-[20px] md:col-span-2" /></div> : stats.error ? <ErrorState onRetry={() => void stats.refetch()} /> : <><BalanceCards balance={stats.data.balance} />{stats.data.totals.clicks === 0 && stats.data.totals.orders === 0 ? <EmptyNote>{t("partner.texts.noStats", {
          defaultValue: UGC_TEXTS.noStats
        })}</EmptyNote> : <div className="grid min-w-0 gap-3 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)]"><Funnel totals={stats.data.totals} /><DailyChart series={stats.data.series} /></div>}<ArticlesTable data={stats.data} arbitrage={arbitrage} /></>;
    $[39] = arbitrage;
    $[40] = stats;
    $[41] = t;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== commissions) {
    t17 = <Commissions query={commissions} />;
    $[43] = commissions;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t15 || $[46] !== t16 || $[47] !== t17) {
    t18 = <section className="flex min-w-0 flex-col gap-4" data-testid="partner-stats">{t15}{t16}{t17}</section>;
    $[45] = t15;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
}
function _temp() {
  return api.ugc.partner.commissions();
}
function BalanceCards(t0) {
  const $ = _c(6);
  const {
    balance
  } = t0;
  const {
    t
  } = useTranslation();
  const fmt = useFormatPrice();
  let t1;
  if ($[0] !== balance) {
    t1 = balance ?? {
      hold: 0,
      available: 0,
      paid: 0,
      cancelled: 0
    };
    $[0] = balance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const b = t1;
  let t2;
  if ($[2] !== b || $[3] !== fmt || $[4] !== t) {
    const cells = [{
      key: "hold"
    }, {
      key: "available",
      accent: true
    }, {
      key: "paid"
    }, {
      key: "cancelled"
    }];
    t2 = <div className="grid grid-cols-2 gap-2 lg:grid-cols-4 lg:gap-3" data-testid="partner-balance">{cells.map(t3 => {
        const {
          key,
          accent
        } = t3;
        return <PartnerCard key={key} className={cn("flex flex-col gap-1.5 p-3 md:p-4", accent && "bg-ds-primary text-white")}><span className={cn("text-[12px] leading-4 font-medium", accent ? "text-white/70" : "text-ds-secondary")}>{t(`partner.stats.balance.${key}`)}</span><span className={cn("text-[18px] leading-6 font-bold tabular-nums md:text-[22px] md:leading-7", !accent && "text-ds-ink")}>{fmt(b[key])}</span>{key === "hold" && <span className="text-[11px] leading-[14px] text-ds-secondary">{t("partner.stats.holdHint")}</span>}</PartnerCard>;
      })}</div>;
    $[2] = b;
    $[3] = fmt;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function Funnel(t0) {
  const $ = _c(27);
  const {
    totals
  } = t0;
  const {
    t
  } = useTranslation();
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t || $[1] !== totals.clicks || $[2] !== totals.completedOrders || $[3] !== totals.orders) {
    const steps = [{
      key: "clicks",
      value: totals.clicks
    }, {
      key: "orders",
      value: totals.orders
    }, {
      key: "completed",
      value: totals.completedOrders
    }] as const;
    const top = Math.max(1, totals.clicks, totals.orders);
    T0 = PartnerCard;
    t3 = "flex min-w-0 flex-col gap-3";
    let t5;
    if ($[9] !== t) {
      t5 = t("partner.stats.funnel");
      $[9] = t;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    if ($[11] !== t5) {
      t4 = <h2 className="text-[16px] leading-5 font-semibold text-ds-ink">{t5}</h2>;
      $[11] = t5;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t1 = "flex flex-col gap-3";
    t2 = steps.map((step, i) => {
      const prev = i > 0 ? steps[i - 1]?.value ?? 0 : 0;
      const share = i > 0 && prev > 0 ? step.value / prev * 100 : null;
      return <li key={step.key} className="flex flex-col gap-1"><div className="flex items-baseline justify-between gap-2 text-[13px] leading-[17px]"><span className="font-medium text-ds-primary">{t(`partner.stats.${step.key}`)}</span><span className="tabular-nums text-ds-secondary"><b className="font-semibold text-ds-ink">{fmtInt(step.value)}</b>{share != null && ` · ${fmtPercent(share)}`}</span></div><div className="h-2.5 overflow-hidden rounded-full bg-ds-quaternary"><div className="h-full rounded-full bg-ds-accent" style={{
            width: `${Math.max(step.value > 0 ? 2 : 0, step.value / top * 100)}%`
          }} /></div></li>;
    });
    $[0] = t;
    $[1] = totals.clicks;
    $[2] = totals.completedOrders;
    $[3] = totals.orders;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2) {
    t5 = <ol className={t1}>{t2}</ol>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t || $[17] !== totals.cr) {
    t6 = t("partner.stats.conversion", {
      value: fmtPercent(totals.cr)
    });
    $[16] = t;
    $[17] = totals.cr;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t6) {
    t7 = <p className="text-[12px] leading-4 text-ds-secondary">{t6}</p>;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== T0 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t7) {
    t8 = <T0 className={t3}>{t4}{t5}{t7}</T0>;
    $[21] = T0;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}

/** Переходы по дням - один ряд столбиков, наведение показывает весь день. */
function DailyChart(t0) {
  const $ = _c(45);
  const {
    series
  } = t0;
  const {
    t
  } = useTranslation();
  const fmt = useFormatPrice();
  const [hover, setHover] = useState(null);
  let t1;
  if ($[0] !== series) {
    t1 = Math.max(1, ...series.map(_temp2));
    $[0] = series;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const max = t1;
  const day = hover != null ? series[hover] : null;
  const step = series.length ? 600 / series.length : 600;
  const bar = Math.max(2, Math.min(18, step - 2));
  const label = _temp3;
  let t2;
  if ($[2] !== t) {
    t2 = t("partner.stats.chart");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2 className="text-[16px] leading-5 font-semibold text-ds-ink">{t2}</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== day || $[7] !== fmt || $[8] !== t) {
    t4 = day ? t("partner.stats.dayTip", {
      day: label(day.day),
      clicks: fmtInt(day.clicks),
      orders: fmtInt(day.orders),
      completed: fmtInt(day.completedOrders),
      commission: fmt(day.commission)
    }) : t("partner.stats.chartHint");
    $[6] = day;
    $[7] = fmt;
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <span className="min-h-4 text-[12px] leading-4 text-ds-secondary tabular-nums" aria-live="polite">{t4}</span>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="flex flex-wrap items-baseline justify-between gap-2">{t3}{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t("partner.stats.chart");
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setHover(null);
    t9 = <line x1={0} x2={600} y1={160} y2={160} stroke="currentColor" className="text-ds-line-2" strokeWidth={1} vectorEffect="non-scaling-stroke" />;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  let t10;
  if ($[19] !== bar || $[20] !== hover || $[21] !== max || $[22] !== series || $[23] !== step) {
    let t11;
    if ($[25] !== bar || $[26] !== hover || $[27] !== max || $[28] !== step) {
      t11 = (d_0, i) => {
        const h = d_0.clicks ? Math.max(3, d_0.clicks / max * 152) : 0;
        const x = i * step + (step - bar) / 2;
        return <g key={d_0.day} onMouseEnter={() => setHover(i)}><rect x={i * step} y={0} width={step} height={160} fill="transparent" />{h > 0 && <rect x={x} y={160 - h} width={bar} height={h} rx={Math.min(4, bar / 2)} className={hover === i ? "fill-ds-accent" : "fill-ds-primary"} />}</g>;
      };
      $[25] = bar;
      $[26] = hover;
      $[27] = max;
      $[28] = step;
      $[29] = t11;
    } else {
      t11 = $[29];
    }
    t10 = series.map(t11);
    $[19] = bar;
    $[20] = hover;
    $[21] = max;
    $[22] = series;
    $[23] = step;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t7) {
    t11 = <svg viewBox="0 0 600 162" preserveAspectRatio="none" className="h-[140px] w-full md:h-[170px]" role="img" aria-label={t7} onMouseLeave={t8}>{t9}{t10}</svg>;
    $[30] = t10;
    $[31] = t7;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== series) {
    t12 = series.length > 0 && <div className="-mt-1 flex justify-between text-[11px] leading-[14px] text-ds-secondary tabular-nums"><span>{label(series[0]?.day ?? "")}</span>{series.length > 2 && <span>{label(series[Math.floor((series.length - 1) / 2)]?.day ?? "")}</span>}<span>{label(series[series.length - 1]?.day ?? "")}</span></div>;
    $[33] = series;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== max || $[36] !== t) {
    t13 = t("partner.stats.chartLegend", {
      max: fmtInt(max)
    });
    $[35] = max;
    $[36] = t;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t13) {
    t14 = <p className="text-[12px] leading-4 text-ds-secondary">{t13}</p>;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t11 || $[41] !== t12 || $[42] !== t14 || $[43] !== t6) {
    t15 = <PartnerCard className="flex min-w-0 flex-col gap-3">{t6}{t11}{t12}{t14}</PartnerCard>;
    $[40] = t11;
    $[41] = t12;
    $[42] = t14;
    $[43] = t6;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  return t15;
}
function _temp3(iso) {
  return new Date(`${iso.slice(0, 10)}T00:00:00`).toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "short"
  });
}
function _temp2(d) {
  return d.clicks;
}
function ArticlesTable(t0) {
  const $ = _c(47);
  const {
    data,
    arbitrage
  } = t0;
  const {
    t
  } = useTranslation();
  const fmt = useFormatPrice();
  if (data.rows.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("partner.articles.code");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("partner.generate.source");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("partner.articles.clicks");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("partner.articles.orders");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("partner.articles.completed");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== arbitrage || $[11] !== t) {
    t6 = arbitrage ? ["CR", t("partner.articles.returns")] : [];
    $[10] = arbitrage;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("partner.articles.gmv");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("partner.articles.commission");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = [t1, t2, t3, t4, t5, ...t6, t7, t8];
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const head = t9;
  let t10;
  if ($[26] !== t) {
    t10 = t("partner.stats.byArticle");
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10) {
    t11 = <h2 className="px-4 pt-4 text-[16px] leading-5 font-semibold text-ds-ink md:px-5 md:pt-5">{t10}</h2>;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== head) {
    t12 = <thead className="text-ds-label"><tr>{head.map(_temp4)}</tr></thead>;
    $[30] = head;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== arbitrage || $[33] !== data.rows || $[34] !== fmt) {
    let t14;
    if ($[36] !== arbitrage || $[37] !== fmt) {
      t14 = r => <tr key={r.key} className="border-t border-ds-line-2"><td className="px-3 py-2 pl-4 md:pl-5"><div className="flex items-center gap-1.5">{r.code ? <CodeChip code={r.code} /> : "-"}{r.status && r.status !== "active" && <StatusBadge status={r.status} />}</div></td><td className="max-w-[220px] px-3 py-2"><p className="truncate font-medium text-ds-primary" title={r.label}>{r.label}</p>{r.productTitle && <p className="truncate text-[12px] text-ds-secondary">{r.productTitle}</p>}</td><td className="px-3 py-2 text-right">{fmtInt(r.metrics.clicks)}</td><td className="px-3 py-2 text-right">{fmtInt(r.metrics.orders)}</td><td className="px-3 py-2 text-right">{fmtInt(r.metrics.completedOrders)}</td>{arbitrage && <><td className="px-3 py-2 text-right">{fmtPercent(r.metrics.cr)}</td><td className="px-3 py-2 text-right">{fmtInt(r.metrics.returns)}</td></>}<td className="px-3 py-2 text-right whitespace-nowrap">{fmt(r.metrics.gmv)}</td><td className="px-3 py-2 pr-4 text-right font-semibold whitespace-nowrap text-ds-ink md:pr-5">{fmt(r.metrics.commission)}</td></tr>;
      $[36] = arbitrage;
      $[37] = fmt;
      $[38] = t14;
    } else {
      t14 = $[38];
    }
    t13 = data.rows.map(t14);
    $[32] = arbitrage;
    $[33] = data.rows;
    $[34] = fmt;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[39] !== t13) {
    t14 = <tbody className="tabular-nums">{t13}</tbody>;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t12 || $[42] !== t14) {
    t15 = <div className="min-w-0 overflow-x-auto pb-2"><table className="w-full min-w-[640px] text-left text-[13px] leading-[17px]" data-testid="partner-stats-table">{t12}{t14}</table></div>;
    $[41] = t12;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t11 || $[45] !== t15) {
    t16 = <PartnerCard className="flex min-w-0 flex-col gap-3 p-0 md:p-0">{t11}{t15}</PartnerCard>;
    $[44] = t11;
    $[45] = t15;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  return t16;
}
function _temp4(h, i) {
  return <th key={h} className={cn("px-3 py-2 font-medium whitespace-nowrap first:pl-4 md:first:pl-5", i >= 2 && "text-right")}>{h}</th>;
}
function Commissions(t0) {
  const $ = _c(14);
  const {
    query
  } = t0;
  const {
    t
  } = useTranslation();
  const fmt = useFormatPrice();
  let t1;
  if ($[0] !== query.data) {
    t1 = query.data ?? [];
    $[0] = query.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const list = t1;
  let t2;
  if ($[2] !== t) {
    t2 = t("partner.stats.commissions");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h2 className="text-[16px] leading-5 font-semibold text-ds-ink">{t2}</h2>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== fmt || $[7] !== list || $[8] !== query.isPending || $[9] !== t) {
    t4 = query.isPending ? <Skeleton className="h-20 rounded-[16px]" /> : list.length === 0 ? <p className="text-[14px] leading-[18px] text-ds-secondary">{t("partner.stats.noCommissions")}</p> : <ul className="flex flex-col divide-y divide-ds-line-2" data-testid="partner-commissions">{list.map(c => <li key={c.id} className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1.5 py-2.5"><div className="flex min-w-0 flex-col gap-0.5"><span className="text-[14px] leading-[18px] font-semibold text-ds-ink">{c.orderNumber ? t("partner.stats.order", {
              number: c.orderNumber
            }) : t("partner.stats.orderNoNumber")}<span className="ml-2 font-mono text-[12px] font-medium text-ds-secondary">{c.code}</span></span><span className="text-[12px] leading-4 text-ds-secondary">{t("partner.stats.base", {
              base: fmt(c.base),
              percent: fmtPercent(c.percent)
            })} · {fmtDate(c.createdAt)}{c.state === "hold" && c.availableAt ? ` · ${t("partner.stats.availableAt", {
              date: fmtDate(c.availableAt)
            })}` : ""}{c.state === "cancelled" && c.stateReason ? ` · ${t(`partner.stats.reason.${c.stateReason}`, {
              defaultValue: c.stateReason
            })}` : ""}</span></div><div className="flex items-center gap-2"><span className={cn("text-[15px] leading-5 font-bold tabular-nums", c.state === "cancelled" ? "text-ds-secondary line-through" : "text-ds-ink")}>{fmt(c.amount)}</span><CommissionStateBadge state={c.state} /></div></li>)}</ul>;
    $[6] = fmt;
    $[7] = list;
    $[8] = query.isPending;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <PartnerCard className="flex min-w-0 flex-col gap-3">{t3}{t4}</PartnerCard>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}